import { DeveloperPermissionItem } from '../../PermissionItem'

const allowMixedCase = true

export const CreateAPIKey = new DeveloperPermissionItem({
  id: 'AB91D78D-15C9-46C0-B88E-0E24D3E7EB10',
  name: 'Create API Key',
  action: 'create API keys',
  allowMixedCase,
})

export const RemoveAPIKey = new DeveloperPermissionItem({
  id: '554A9E21-FBF4-49A8-9312-2559C867F67F',
  name: 'Remove API Key',
  action: 'remove API keys',
  allowMixedCase,
})

export const ViewAPIKey = new DeveloperPermissionItem({
  id: '5451CE7B-D5A9-4AFC-B7CB-17D3DB70E8F5',
  name: 'View API Key',
  action: 'view API keys',
  allowMixedCase,
})

export const AssociateProjectWithCIMS = new DeveloperPermissionItem({
  id: '35554919-7A23-4541-8138-9D2229BE8A06',
  name: 'Associate Project with CIMS',
  action: 'associate a project with CIMS',
  allowMixedCase,
})

export const SyncUsers = new DeveloperPermissionItem({
  id: '07D4DEC4-262B-4B9D-8A2D-1D01FF39DCF8',
  name: 'Sync Users',
  action: 'sync users',
})

export const EditRFIResponse = new DeveloperPermissionItem({
  id: '79426DAC-D05D-4E49-A2D7-7F4CBE66BBE2',
  name: 'Edit RFI Response',
  action: 'edit RFI responses',
})

export type DeveloperPermission =
  | typeof CreateAPIKey
  | typeof RemoveAPIKey
  | typeof ViewAPIKey
  | typeof AssociateProjectWithCIMS
  | typeof SyncUsers
  | typeof EditRFIResponse
